
import { Box, Button, Typography } from '@mui/material'

import { Links } from 'constants/Paths'

const promotionalTextStyles = {
  fontSize: '18px',
  fontWeight: 600,
  color: '#1D1A33',
  textAlign: 'center' as const,
  mb: 2,
  lineHeight: '150%',
  letterSpacing: '0.15px',
}

const feedbackButtonStyles = {
  borderRadius: '8px',
  py: 1.5,
  lineHeight: '150%',
  letterSpacing: '0.15px',
  fontWeight: 600,
  fontSize: '13.33px',
  textTransform: 'none' as const,
  backgroundColor: 'white',
  border: '2px solid #7B2A8D',
  backgroundImage: 'linear-gradient(135deg, #471D7C 0%, #C6007E 100%)',
  backgroundClip: 'text',
  color: 'transparent',
  '&:hover': {
    backgroundColor: '#FCF0F9',
    border: '2px solid #7B2A8D',
    backgroundImage: 'linear-gradient(135deg, #471D7C 0%, #C6007E 100%)',
    backgroundClip: 'text',
    color: 'transparent',
  },
}

const signUpButtonStyles = {
  background: 'linear-gradient(135deg, #471D7C 0%, #C6007E 100%)',
  color: 'white',
  fontWeight: 600,
  fontSize: '13.33px',
  textTransform: 'none' as const,
  borderRadius: '8px',
  py: 1.5,
  mt: 1,
  border: 0,
  lineHeight: '150%',
  letterSpacing: '0.15px',
  '&:hover': {
    background: 'linear-gradient(135deg, #3a1766 0%, #a5006a 100%)',
  },
}

export const DeliveryFeedbackActions = () => {
  const handleContactClick = () => {
    window.open(Links.talkToExpert, '_blank', 'noopener,noreferrer')
  }

  const handleFeedbackClick = () => {
    window.open(Links.talkToExpert, '_blank', 'noopener,noreferrer')
  }

  return (
    <Box sx={{ mt: '0.5px' }}>
      <Typography sx={promotionalTextStyles}>
        You&apos;ve seen how easy delivery can be with FirstPoint.
      </Typography>
      <Button fullWidth variant='outlined' sx={feedbackButtonStyles} onClick={handleFeedbackClick}>
        Give Feedback
      </Button>
      <Button fullWidth variant='contained' sx={signUpButtonStyles} onClick={handleContactClick}>
        Contact us for your deliveries
      </Button>
    </Box>
  )
}
